import styled from 'styled-components';

const Name = styled.span`
  display: block;
  font-size: 0.9375rem;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${Styles.fontFamily.base};
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export default Name;
